import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 施設関係者メッセージ送信にひもづくメンバー API 操作クラス
 */
export default class OtherUserGroupSendMessageReadMembers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET SendMessageReadOtherUsers
   */
  public async get(userStore: LoginUser, datetime: number): Promise<Array<OtherUserGroupSendMessageReadMemberModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupSendMessageReadMembers, formatParams);
    const response = await this.commonService.executeGet<Array<OtherUserGroupSendMessageReadMemberModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      {},
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

/**
 * メッセージ送信にひもづく施設関係者
 */
export interface OtherUserGroupSendMessageReadMemberModel {
  /** グループを示すID */
  groupId: number;
  /** グループメンバーを示すID */
  groupMemberId: number;
  /** 施設関係者グループ名 */
  groupName: string;
  /** 施設関係者グループの種類 ID */
  groupTypeId: number;
  /** 施設関係者グループ種類名 */
  groupTypeName: string;
  /** 施設関係者グループメンバー名 */
  groupMemberName: string;
  /** 施設関係者グループメンバー電話番号 */
  groupMemberTel: string;
  /** 施設関係者グループメンバー所属 */
  groupMemberOrganization: string;
  /** 既読時間、未読の場合はundefinedが格納されている */
  readDatetime: number | undefined;
}
